import React from 'react';
import TermsSection, { SectionText, BulletPoint } from './TermsSection';

const AcceptableUse = () => {
  return (
    <TermsSection title="2. Acceptable Use">
      <SectionText>By accessing Campus Insights, you agree to:</SectionText>
      <BulletPoint>• Use the service only for lawful, educational purposes</BulletPoint>
      <BulletPoint>• Avoid submitting offensive, illegal, or malicious content</BulletPoint>
      <BulletPoint>• Not attempt to reverse-engineer, scrape, or interfere with the platform</BulletPoint>
      <SectionText>
        You are responsible for securing any access credentials and all activity undertaken under your account. Misuse may result in restricted or terminated access.
      </SectionText>
    </TermsSection>
  );
};

export default AcceptableUse;
